module.exports = __webpack_public_path__ + "static/media/three_dots.1ae7b149.svg";